import React from "react";
import {
  TouchableOpacity,
  Text,
  InputAccessoryView,
  Platform,
  Keyboard,
  StyleSheet,
} from "react-native";

const KeyboardDoneButton = ({
  inputAccessoryViewID,
  onPrevPress,
  onNextPress,
  showPrevNext = false,
}: {
  inputAccessoryViewID: string;
  onPrevPress?: () => void;
  onNextPress?: () => void;
  showPrevNext?: boolean;
}) => {
  if (Platform.OS !== "ios") {
    return null;
  }

  return (
    <InputAccessoryView nativeID={inputAccessoryViewID}>
      <TouchableOpacity style={styles.accessoryBar} activeOpacity={1}>
        {showPrevNext && (
          <TouchableOpacity style={styles.navGroup} activeOpacity={1}>
            <TouchableOpacity
              style={[
                styles.navButton,
                !onPrevPress && styles.navButtonDisabled,
              ]}
              onPress={onPrevPress}
              disabled={!onPrevPress}
            >
              <Text
                style={[
                  styles.navButtonText,
                  !onPrevPress && styles.navButtonTextDisabled,
                ]}
              >
                Prev
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.navButton,
                !onNextPress && styles.navButtonDisabled,
              ]}
              onPress={onNextPress}
              disabled={!onNextPress}
            >
              <Text
                style={[
                  styles.navButtonText,
                  !onNextPress && styles.navButtonTextDisabled,
                ]}
              >
                Next
              </Text>
            </TouchableOpacity>
          </TouchableOpacity>
        )}
        <TouchableOpacity
          style={[styles.doneButton, !showPrevNext && styles.doneButtonSolo]}
          onPress={() => Keyboard.dismiss()}
        >
          <Text style={styles.doneButtonText}>Done</Text>
        </TouchableOpacity>
      </TouchableOpacity>
    </InputAccessoryView>
  );
};

const styles = StyleSheet.create({
  accessoryBar: {
    backgroundColor: "#f8f8f8",
    borderTopWidth: 1,
    borderTopColor: "#dedede",
    paddingHorizontal: 12,
    paddingVertical: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  navGroup: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  navButton: {
    paddingVertical: 6,
    paddingHorizontal: 8,
  },
  navButtonDisabled: {
    opacity: 0.4,
  },
  navButtonText: {
    color: "#007AFF",
    fontSize: 16,
  },
  navButtonTextDisabled: {
    color: "#007AFF",
  },
  doneButton: {
    paddingVertical: 6,
    paddingHorizontal: 8,
    alignItems: "flex-end",
  },
  doneButtonSolo: {
    marginLeft: "auto",
  },
  doneButtonText: {
    color: "#007AFF",
    fontSize: 16,
  },
});

export default KeyboardDoneButton;
